// extracted by mini-css-extract-plugin
export default {"about":"PopupUploadFeaturedImage_about__p1ClV","imageDim":"PopupUploadFeaturedImage_imageDim__hs3M1","bottom":"PopupUploadFeaturedImage_bottom__4cTCD"};